import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/utils/cn';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('border-line rounded-xl border bg-white shadow-sm', className)} {...props} />
  );
}

export function CardHeader({
  title,
  subtitle,
  action,
  wrapAction = false,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  /** Moves the action below the title when the card is too narrow for both, so neither the title nor a button label is squeezed onto extra lines. */
  wrapAction?: boolean;
}) {
  return (
    <div
      className={cn(
        'border-line flex items-start justify-between gap-4 border-b px-5 py-4',
        wrapAction && 'flex-wrap',
      )}
    >
      <div className={wrapAction ? 'min-w-0 grow basis-48' : undefined}>
        <h2 className="text-ink text-base font-semibold">{title}</h2>
        {subtitle ? <p className="text-muted mt-0.5 text-sm">{subtitle}</p> : null}
      </div>
      {action}
    </div>
  );
}

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('px-5 py-4', className)} {...props} />;
}
